var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 183,
    viewBox: "0 0 205 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.15 203.858C169.33 193.881 178.55 181.535 185.38 168.473C197.12 146.025 200.03 116.244 177.67 100.298C164.59 90.9944 146.12 89.0239 128.92 89.581C111.72 90.138 94.4899 92.7985 77.3899 91.1274C60.2899 89.4563 42.5499 82.2563 35.9199 69.0452C30.9199 59.1265 32.9899 47.5533 28.2799 37.5431C19.8699 19.6844 -4.4501 6.64794 -26.9801 10.7634C-49.5101 14.8789 -71.7901 33.1699 -91.2101 43.5126C-120.58 59.168 -154.15 71.8304 -188.98 70.2757",
    stroke: "#FDB8FF",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4498 222.282C117.85 206.485 166.45 162.221 147.58 135.059C143.5 129.173 135.88 125.415 127.95 123.777C109.14 119.894 89.2698 124.924 70.2998 125.032C51.5098 125.14 34.1598 121.116 20.2098 110.375C2.20976 96.5317 11.7598 69.6938 -7.48024 55.7012C-29.3502 39.813 -55.7202 60.7895 -70.2302 73.0527C-103.76 101.379 -148.62 108.28 -195 106.908",
    stroke: "#FCD4E5",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave1);
export default __webpack_public_path__ + "static/media/wave1.dea2121f72cc0d04598e712a9295001a.svg";
export { ForwardRef as ReactComponent };